import { useMemo } from 'react';
import { carFilter } from '@apps/config/car-filter.config';
import {
  CapacityType,
  FuelType,
  SeatType,
  SegmentType,
  TransmissionType,
} from '@apps/screens/NewCar';
import { generateOptions } from '@apps/utils/generate-options';

export type SvgType = {
  default: string;
  active: string;
};

export type FilterOptions = {
  label: string;
  value: number | string;
  svg?: SvgType;
};

export type Filter = {
  mode: 'checkbox' | 'slider';
  title: string;
  options: FilterOptions[];
  key: string;
};

export type FilterItemsOption = {
  budget: number[];
  monthly_payment: number[];
  segment: SegmentType[];
  capacity: CapacityType[];
  fuel_type: FuelType[];
  transmission: TransmissionType[];
  seat: SeatType[];
};

export const useFilterValues = ({
  budget,
  monthly_payment,
  segment,
  capacity,
  fuel_type,
  transmission,
  seat,
}: FilterItemsOption) => {
  const filterItems = useMemo(() => {
    // TODO: remove slice last
    const budgetList = generateOptions({ list: budget?.slice(0, -1) });
    const monthlyPaymentList = generateOptions({
      list: monthly_payment?.slice(0, -1),
    });
    const segmentList = generateOptions({
      list: segment,
      labelKey: 'car_segment_type_name',
      valueKey: 'car_segment_type_slug',
      withAllOptions: true,
    });
    const capacityList = generateOptions({
      list: capacity,
      labelKey: 'capacity_name',
      valueKey: 'capacity_slug',
      withAllOptions: true,
    });
    const fuelTypeList = generateOptions({
      list: fuel_type,
      labelKey: 'car_fuel_type_name',
      valueKey: 'car_fuel_type_slug',
      withAllOptions: true,
    });
    const seatList = generateOptions({
      list: seat,
      labelKey: 'seat_name',
      valueKey: 'seat_slug',
      withAllOptions: true,
    });
    const transmissionList = generateOptions({
      list: transmission,
      labelKey: 'transmission',
      valueKey: 'transmission',
      withAllOptions: true,
    });

    return [
      {
        mode: 'slider',
        key: 'budget',
        title: 'Budget (RM)',
        options: budgetList ?? [],
      },
      {
        mode: 'slider',
        key: 'monthly_payment',
        title: 'Monthly Payment (RM)',
        options: monthlyPaymentList ?? [],
      },
      {
        mode: 'checkbox',
        key: 'body_type',
        title: 'Body Type',
        options: carFilter,
      },
      {
        mode: 'checkbox',
        key: 'segment',
        title: 'Segment',
        options: segmentList ?? [],
      },
      {
        mode: 'checkbox',
        key: 'capacity',
        title: 'Capacity',
        options: capacityList ?? [],
      },
      {
        mode: 'checkbox',
        key: 'transmission',
        title: 'Transmission',
        options: transmissionList ?? [],
      },
      {
        mode: 'checkbox',
        key: 'fuel_type',
        title: 'Fuel',
        options: fuelTypeList ?? [],
      },
      {
        mode: 'checkbox',
        key: 'seat',
        title: 'Seat',
        options: seatList ?? [],
      },
    ] as Filter[];
  }, [
    budget,
    monthly_payment,
    segment,
    capacity,
    fuel_type,
    transmission,
    seat,
  ]);
  return filterItems;
};
